:host {
  display: block;

}
lgr-carousel-item {
  > * {
    width: 100%;
  }
}